import { createContext, useState, useCallback } from 'react';

export const TradesContext = createContext();

export function TradeContextProvider({ children }) {
  const [formValues, setFormValues] = useState({
    tradeWindow: '',
    transferWindow: '',
    settlementWindow: '',
    notes: '',
  });

  const [matchingData, setMatchingData] = useState({
    success: false,
    records: [],
  });

  const [tradeResponse, setTradeResponse] = useState(null);

  const [currentStep, setCurrentStep] = useState(0);

  const [openModal, setOpenModal] = useState(false);

  // Form reference for external validation
  const [formInstance, setFormInstance] = useState(null);

  const registerForm = useCallback((form) => {
    setFormInstance(form);
  }, []);

  const validateForm = useCallback(async () => {
    if (!formInstance) return false;
    try {
      const values = await formInstance.validateFields();

      setFormValues(
        {
          tradeWindow: values.tradeWindow,
          transferWindow: values.transferWindow,
          settlementWindow: values.settlementWindow,
          notes: values.notes,
        }
      )
      return values;
    } catch (error) {
      return false;
    }
  }, [formInstance]);

  const resetForm = useCallback(() => {
    if (!formInstance) return;
    formInstance.resetFields();
  }, [formInstance]);

  return (
    <TradesContext.Provider
      value={{
        formValues,
        setFormValues,
        matchingData,
        setMatchingData,
        currentStep,
        setCurrentStep,
        openModal,
        setOpenModal,
        registerForm,
        validateForm,
        resetForm,
        tradeResponse,
        setTradeResponse,
      }}
    >
      {children}
    </TradesContext.Provider>
  );
}
